<script setup>
  const props = defineProps({
    grayscale: Boolean,
    grayscaleAccent: Boolean,
    dark: Boolean,
    prefix: Boolean,
    suffix: Boolean,
    plus: Boolean,
    arrow: Boolean,
    disabled: Boolean
  })
  const emits = defineEmits([ 'click' ])
</script>

<template>
  <div class="base-button" :class="{ 'grayscale': props.grayscale, 'grayscale-accent': props.grayscaleAccent, 'disabled': props.disabled, 'dark': props.dark }" @click="emits('click')">
    <div v-if="prefix" class="base-button__prefix">
      <template v-if="plus">
        +
      </template>
      <template v-else>
        <slot name="prefix">
          prefix
        </slot>
      </template>
    </div>
    <span class="base-button__label">
      <slot name="label">
        label
      </slot>
    </span>
    <span v-if="suffix" class="base-button__suffix">
       <template v-if="arrow">
        >
      </template>
      <slot name="suffix" v-else>
        suffix
      </slot>
    </span>
  </div>
</template>

<style lang="scss" scoped>
  .base-button {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    padding: 16px;
    border-radius: 12px;
    border: 1px solid var(--accent-bg);

    background-color: var(--accent-bg);
    color: var(--text-color-primary-reverse);

    transition: 0.4s ease all;

    &.dark {
      color: var(--text-color);
      background-color: var(--main-bg);
      border-color: var(--main-bg);
    }

    &.grayscale {
      color: var(--text-color);
      background-color: var(--element-bg);
      border-color: var(--border-color);

      &:hover {
        transition: 0.4s ease all;
        background-color: var(--element-bg-lighter);
      }
    }

    &.grayscale-accent {
      transition: 0.4s ease all;

      color: var(--text-color);
      background-color: var(--element-bg-accent);
      border-color: var(--border-color);

      &:hover {
        transition: 0.4s ease all;

        background-color: var(--accent-bg);
        color: var(--text-color-primary-reverse);
        border-color: var(--accent-bg);
      }
    }

    &.disabled {
      transition: 0.4s ease all;

      pointer-events: none;
      color: var(--text-color-disabled);
      background-color: var(--element-bg);
      border-color: var(--element-bg);
    }

    cursor: pointer;

    font-size: 16px;
    font-weight: 500;

    .base-button__prefix {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .base-button__label {
      text-align: center;
    }
    .base-button__suffix {
      display: flex;
      align-items: center;
      transition: transform 0.4s ease-out;
    }

    &:hover {
      .base-button__suffix {
        transform: translateX(5px);
      }
    }

    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    @media (max-width: 920px) {
      &.grayscale {
        background-color: var(--layout-bg);

        &:hover {
          background-color: var(--layout-bg-lighter);
        }
      }
      &.grayscale-accent {
        background-color: var(--layout-bg);
      }
      &.disabled {
        background-color: var(--layout-bg);
        border-color: var(--layout-bg);
      }
    }
  }
</style>